import {useMemo} from 'react';
import type {DataLoadStatus} from 'api/types';
import type {NationalAgent} from 'services/agent/types';
import {useGetAgentByNationalIdQuery} from 'services/agent';
import {mapRtkToDataLoad} from 'store/api';

export const useAgentNoraf = (agent: Pick<NationalAgent, 'nationalId'>) => {
  const {data, status, error} = useGetAgentByNationalIdQuery(
    agent.nationalId!,
    {skip: !agent.nationalId},
  );

  return useMemo<DataLoadStatus<NationalAgent>>(
    () => mapRtkToDataLoad(status, data, error),
    [status, data, error],
  );
};
